import { api } from './axios'
import type { Aluno } from '@/types'

export interface DadosEditaveisDaMatricula {
  matriculaId: number
  nome: string
  email: string
  telefone: string
  municipio: string
  categoriaCnh: string
  dataPrimeiraHabilitacao: string
  renach: string
}

export async function getAlunoByCpf(cpf: string): Promise<Aluno> {
  const response = await api.get<Aluno>('/parceiros/buscar-aluno', { params: { cpf } })
  return response.data
}

// `estado` fica de fora: o backend o usa para sobrescrever matricula.uf. E uma data vazia precisa
// ser omitida, não enviada como '': o endpoint a repassa crua para a coluna e o update inteiro falha.
export async function updateAlunoDaMatricula(
  cpf: string,
  dados: DadosEditaveisDaMatricula
): Promise<{ success: boolean }> {
  const { dataPrimeiraHabilitacao, ...resto } = dados
  const response = await api.put<{ success: boolean }>(`/usuarios/${cpf}`, {
    ...resto,
    ...(dataPrimeiraHabilitacao ? { dataPrimeiraHabilitacao } : {}),
  })
  return response.data
}
